import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import { regex } from "vee-validate/dist/rules";
import { min, max, numeric } from "vee-validate/dist/rules";

extend("regex", regex);

extend("email", {
  ...email,
  message: "Enter a email address"
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("username", {
  ...required,
  message: "Username is required"
});

extend("confirmed", {
  ...confirmed,
  message: "Password confirmation does not match"
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Password confirmation does not match"
});

const phoneno = /^\d{11}$/;
extend("phoneNumber", {
  validate(value) {
    return value.match(phoneno);
  },
  message: "Phone number not valid"
});

extend("min", min);
extend("max", max);
extend("numeric", numeric);
